import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SearchFormForCustomers() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState({
    name: searchParams.get("name") || "",
    phone: searchParams.get("phone") || "",
    email: searchParams.get("email") || "",
    registrationDateFrom: searchParams.get("registrationDateFrom") || "",
    registrationDateTo: searchParams.get("registrationDateTo") || "",
  });

  const handleChange = (key: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Merge current search params with form filters
    const newParams = new URLSearchParams(searchParams.toString());

    Object.entries(filters).forEach(([key, value]) => {
      if (value) newParams.set(key, value);
      else newParams.delete(key);
    });

    if (newParams.toString()) newParams.set("page", "1");

    setSearchParams(newParams);
  };

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams.toString());
    Object.entries(filters).forEach(([key, value]) => {
      if (!value && newParams.has(key)) {
        newParams.delete(key);
      }
    });
    setSearchParams(newParams);
  }, [filters, searchParams, setSearchParams]);

  return (
    <form onSubmit={handleSubmit}>
      {/* Text Inputs */}
      <div className="flex flex-wrap gap-5">
        <input
          type="text"
          placeholder={t("search_by_name")}
          value={filters.name}
          onChange={(e) => handleChange("name", e.target.value)}
          className="border rounded-lg px-3 py-2 flex-1 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="text"
          placeholder={t("search_by_phone")}
          value={filters.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
          className="border rounded-lg px-3 py-2 flex-1 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="text"
          placeholder={t("search_by_email")}
          value={filters.email}
          onChange={(e) => handleChange("email", e.target.value)}
          className="border rounded-lg px-3 py-2 flex-1 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>

      {/* Date Inputs with Clear Buttons */}
      <div className="flex flex-wrap gap-5 mt-5 items-end">
        <div className="flex flex-col flex-1">
          <label className="text-sm text-gray-600 mb-1">{t("registration_date_from")}</label>
          <div className="relative">
            <input
              type="date"
              value={filters.registrationDateFrom}
              onChange={(e) => handleChange("registrationDateFrom", e.target.value)}
              className="border rounded-lg px-3 py-2 pr-8 w-full focus:outline-none focus:ring-2 focus:ring-primary"
            />
            {filters.registrationDateFrom && (
              <button
                type="button"
                onClick={() => handleChange("registrationDateFrom", "")}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        <div className="flex flex-col flex-1">
          <label className="text-sm text-gray-600 mb-1">{t("registration_date_to")}</label>
          <div className="relative">
            <input
              type="date"
              value={filters.registrationDateTo}
              onChange={(e) => handleChange("registrationDateTo", e.target.value)}
              className="border rounded-lg px-3 py-2 pr-8 w-full focus:outline-none focus:ring-2 focus:ring-primary"
            />
            {filters.registrationDateTo && (
              <button
                type="button"
                onClick={() => handleChange("registrationDateTo", "")}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
              >
                ✕
              </button>
            )}
          </div>
        </div>


        <button
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/80 transition"
        >
          <Search />
        </button>
      </div>
    </form>
  );
}
